import { useSiteData } from "@/context/SiteDataContext";
import { useT } from "@/lib/useSiteText";

export default function Testimonials() {
  const { data } = useSiteData();
  const tx = useT();
  const etiqueta = tx("home.testimonios.etiqueta");
  const testimonios = data.testimonios;

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <div className="text-center max-w-2xl mx-auto">
          {etiqueta && <span className="text-sm font-semibold text-accent-600">{etiqueta}</span>}
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            {tx("home.testimonios.titulo")}
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonios.map((t) => (
            <figure
              key={t.id}
              className="rounded-lg bg-background-50 border border-background-200 p-6 flex flex-col"
            >
              <i className="ri-double-quotes-l text-3xl text-accent-300" />
              <blockquote className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed flex-1">
                {t.texto}
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-background-200 flex items-center gap-3">
                <span
                  className={`w-11 h-11 rounded-full ${t.color} text-background-50 flex items-center justify-center font-heading font-bold text-sm`}
                >
                  {t.inicial}
                </span>
                <div className="leading-tight">
                  <p className="font-heading font-semibold text-foreground-900 text-sm">{t.nombre}</p>
                  <p className="text-xs text-foreground-500">{t.cargo}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}